<mat-toolbar class="light-navbar" *ngIf="!isLoginPage" [dir]="getDirection()">
  <div class="navbar-logo">
    <button mat-icon-button class="toggle-btn" (click)="toggleSidebar()">
      <mat-icon>{{ isSidebarOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
    <ng-container *ngIf="isEtabSelected">
      <img *ngIf="etabLogoUrl" [src]="etabLogoUrl" alt="Establishment Logo" class="logo-img" (error)="onEtabLogoError()" />
      <mat-icon *ngIf="!etabLogoUrl" class="logo-fallback" aria-hidden="false" aria-label="No establishment logo">business</mat-icon>
    </ng-container>
  </div>
  <span class="spacer"></span>
  <div class="navbar-right" *ngIf="isEtabSelected">
    <!-- Language switcher - First -->
    <div class="language-container" *ngIf="isUserRole">
      <button mat-icon-button class="lang-btn" (click)="toggleLanguage()">
        <mat-icon>language</mat-icon>
      </button>
      <span class="current-lang">{{ languageService.getCurrentLang() | uppercase }}</span>
    </div>
    <!-- Chat button with unread badge -->
    <button mat-icon-button class="chat-btn" (click)="openChat()" aria-label="Open chat">
      <mat-icon>chat</mat-icon>
      <span
        *ngIf="unreadMessageCount > 0 && !isChatPage"
        class="unread-badge"
        [attr.aria-label]="unreadMessageCount + ' unread messages'"
      >
        {{ unreadMessageCount }}
      </span>
    </button>
    <!-- Kafala expiration button with badge -->
    <button
      mat-icon-button
      class="kafala-btn"
      (click)="openKafalaExpirations()"
      aria-label="View expiring kafalas"
      *ngIf="!isKafalaPage && isAdminOrSuperAdmin"
    >
      <mat-icon>notifications</mat-icon>
      <span
        *ngIf="expiringKafalaCount > 0"
        class="unread-badge"
        [attr.aria-label]="expiringKafalaCount + ' expiring kafalas'"
      >
        {{ expiringKafalaCount }}
      </span>
    </button>
    <!-- Profile button - Last -->
    <button mat-button [matMenuTriggerFor]="settingsMenu" class="profile-btn">
      <ng-container>
        <img
          *ngIf="profilePictureUrl"
          [src]="profilePictureUrl"
          alt="Profile Picture"
          class="profile-img"
          (error)="onProfileImageError()"
        />
        <mat-icon *ngIf="!profilePictureUrl" class="profile-fallback" aria-hidden="false" aria-label="No profile picture">account_circle</mat-icon>
      </ng-container>
      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #settingsMenu="matMenu" class="light-dropdown">
      <button mat-menu-item routerLink="/profil-user" *ngIf="isUserRole">
        <mat-icon>person</mat-icon>
        <span>{{ 'PROFILENAVBAR' | translate }}</span>
      </button>
      <ng-container *ngIf="!isUserRole">
        <button mat-menu-item routerLink="/list-etablissement">
          <mat-icon>business</mat-icon>
          <span>{{ 'ESTABLISHMENTS' | translate }}</span>
        </button>
        <!-- <button mat-menu-item routerLink="/list-user">
          <mat-icon>group</mat-icon>
          <span>{{ 'LIST_USERS' | translate }}</span>
        </button> -->
        <button mat-menu-item routerLink="/profil-user">
          <mat-icon>person</mat-icon>
          <span>{{ 'PROFILENAVBAR' | translate }}</span>
        </button>
      </ng-container>
      <button mat-menu-item (click)="logOut()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'LOGOUT' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>